module.exports = new __parcel__URL__("bossfight_victory_return_home_button.58482643.png").toString();